module.exports = __webpack_public_path__ + "img/auto.9c92f2b5.gif";